<template>
  <generic-link
    class="nav-link login"
    title="User Login"
    @click.native.prevent="loginLinkClicked"
  >
    <login-svg-icons
      name="LoginIcon"
    />
    <span class="nav-label">
      Login
    </span>
  </generic-link>
</template>

<script>
import LoginSvgIcons from './login-svg-icons'

export default {
  name: 'user-login-popup',
  components: {
    LoginSvgIcons
  },
  methods: {
    loginLinkClicked() {
      this.$eventHub.$emit('showLoginModal')
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
